import React, { useEffect, useState } from 'react'

const Navbar = (props) => {

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, [])

    const [scrolled, setScrolled] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false)

    const handleScroll = (event) => {
       
            if(window.pageYOffset > 100){
                setScrolled(true)
                console.log("Scrolled setting to true ",scrolled)
            }
            if(window.pageYOffset <= 100){
                setScrolled(false)
                console.log("Scrolled setting to false ",scrolled)
            }

            console.log("Scroll Value: ",window.pageYOffset)
    }
    

    const onMenuToggle = () => {
        console.log('menu togglinbg')
        setIsMenuOpen(!isMenuOpen)
    }


    const Sidebar = () => {
        return (
            <>
                {/* <div style={{height: '100vh', zIndex: -50}} className={`transparent d-none ${isMenuOpen === true ? ' open-closer' : ''}`} onClick={onMenuToggle}>
                    
                </div> */}
                <div className={`grey darken-4 sidebar-menu${isMenuOpen === true ? ' open' : ''}`}>
                    <div className="pt-4 pb-4" style={{paddingLeft: '40px', paddingRight: '40px'}}>
                        <span className=" float-right" onClick={onMenuToggle}><i className="fa fa-times white-text" /></span>
                        <h6 className="green-text">NAVIGATION</h6>
                    </div>
                    <ul style={{listStyleType: 'none'}}>
                        <li className="pt-3"><a className="white-text bold">Home</a></li>
                        <li className="pt-3"><a className="white-text bold">About</a></li>
                        <li className="pt-3"><a className="white-text bold">Services</a></li>
                        <li className="pt-3"><a className="white-text bold">Works</a></li>
                        <li className="pt-3"><a className="white-text bold">Technologies</a></li>
                        <li className="pt-3"><a className="white-text bold">Contact</a></li>
                    </ul>

                    <div className="mt-5"  style={{paddingLeft: '40px', paddingRight: '40px'}}>
                        <span className="grey-text text-darken-3 ">
                            Perspiciatis hic praesentium nesciunt. Et neque a dolorum voluptatem porro iusto sequi veritatis libero enim. Iusto id suscipit veritatis neque reprehenderit.
                        </span>
                    </div>
                </div>
            </>
        )
    }
  
    return (
        <div>
            <div className="container-fluid">
                {Sidebar()}
                <div className="row">
                    <div className="col-sm-12">
                        <div className="pull-left"><span className="white-text f-lg bold ">Karot<span className="f-xxl green-text bold">.</span></span></div>
                        <div className={`pull-right pointer transition-color m-2 pt-1 pb-1 px-2 ${scrolled ? " abosolute-side-btn" : ""}`}><span className="green-text f-sm ff-mono" style={{letterSpacing: 3}} onClick={() => onMenuToggle()}>MENU <i className="fa fa-bars white-text"></i></span></div>
                    </div>
                </div>
               
            </div>
      
        </div>
    );
  }
  
  export default Navbar;